import { User, UserId } from 'framework/users'
import { EcommerceService } from 'services'
import type { CustomerUpdatePayload } from '.'

class CustomerService extends EcommerceService {
  private customerId: UserId = ('' as unknown) as UserId

  private customer: User = ({} as unknown) as User

  constructor(customer: User = ({} as unknown) as User) {
    super()
    this.setCustomer(customer)
  }

  setCustomer(customer: User): CustomerService {
    this.customer = customer
    return this
  }

  getCustomer() {
    return this.customer
  }

  getCustomerById() {
    const { id } = this.getCustomer()
    const url = `/customers/${id}`
    const req = this.setUrl(url).get()
    return req
  }

  updateCustomer(payload: CustomerUpdatePayload) {
    const { id } = this.getCustomer()
    const url = `/customers/${id}`
    const req = this.setUrl(url).post(payload)
    return req
  }
}

export default CustomerService
